// Action Button
export const CHECK_ACTION_BUTTON_CLICK = "checkActionButtonClick";
export const CLOSE_ACTION_BUTTON_CLICK = "closeActionButtonClick";
export const SAVE_CLOSE_ACTION_BUTTON_CLICK = "saveCloseActionButtonClick";
export const SEND_ACTION_BUTTON_CLICK = "sendActionButtonClick";

// Action Panel
export const ACCEPT_CONVERT_CLICK = "acceptConvertClick";
export const CLEAR_PANEL_CLICK = "clearPanelClick";
export const RESTORE_TO_SOURCE_FUF_CLICK = "restoreToSourceFufClick";
export const OPEN_TEMPLATES_CLICK = "openTemplatesClick";
export const CONVERT_PANEL_CLICK = "convertPanelClick";
export const FEEDBACK_PANEL_CLICK = "feedbackPanelClick";
export const FUF_PANEL_CLICK = "fufPanelClick";
export const ENABLE_AUTO_VALUES = "enableAutoValues";
export const UPLOAD_PANEL_CLICK = "uploadPanelClick";
export const PRINT_PANEL_CLICK = "printPanelClick";
export const TEMPLATES_PANEL_CLICK = "templatesPanelClick";
export const TOUR_PANEL_CLICK = "tourPanelClick";
export const HIDE_ORG_NAME_PANEL_CLICK = "hideOrgNamePanelClick";
export const MORE_ACTIONS_CLICK = "moreActionsClick";
export const HISTORY_EDITING_OPEN_CLICK = "historyEditingOpenClick";
export const HISTORY_EDITING_CLOSE_CLICK = "historyEditingCloseClick";
export const UPLOAD_FUF_ATTACHMENTS_PANEL_CLICK = "uploadFufAttachmentsPanelClick";

// AttachmentForm
export const ATTACHMENT_FORM_OPEN_EMPTY = "attachmentFormOpenEmpty";
export const ATTACHMENT_FORM_OPEN_FUF = "attachmentFormOpenFuf";
export const ATTACHMENT_FORM_REMOVE = "attachmentFormRemove";
export const ATTACHMENT_FORM_REMOVE_OPENED = "attachmentFormRemoveOpened";
export const ATTACHMENT_FORM_CLEAR_OPENED = "attachmentFormRemoveClear";

// ColgroupButton
export const COLGROUP_BUTTON_CLICK = "colgroupButtonClick";

// Embedded Log
export const ERROR_LOG_NAVIGATE_CLICK = "errorLogNavigateClick";
export const ERROR_LOG_OPEN_FULL_RESULT = "errorLogOpenFullResultClick";
export const ERROR_LOG_JUSTIFICATION_CLICK = "errorLogJustificationClick";
export const ERROR_LOG_COUNTER = "errorLogCounter";
export const POPD_PROTOCOL_COUNTER = "popdProtocolCounter";
export const PRINT_EMBEDDEDLOG_CLICK = "printEmbeddedlogClick";
export const PRINT_EMBEDDEDLOG_FROM_MODAL_CLICK = "printEmbeddedlogFromModalClick";
export const ERROR_LOG_MODAL_SWITCH_PAGE = "embeddedlogModalSwitchPage";
export const ERROR_LOG_MODAL_CLOSE = "embeddedlogModalClose";

// FilterDateRange
export const FILTER_DATE_TYPE = "filterDateType";

// FilterInfo
export const FILTER_RESET = "filterReset";

// FilterInput
export const FILTER_INPUT_TYPE = "filterInputType";

// FilterList
export const FILTER_LIST_SEARCH = "filterListSearch";
export const FILTER_LIST_CHECKED = "filterListChecked";

// FileLoader
export const FILE_LOADER_CLICK = "fileLoaderClick";
export const FILE_LOADER_MANY_FILES_MODAL = "fileLoaderManyFilesModal";
export const FILE_LOADER_MANY_FILES_MODAL_ADD = "fileLoaderManyFilesModalAdd";
export const FILE_LOADER_MANY_FILES_MODAL_CLOSE = "fileLoaderManyFilesModalClose";
export const FILE_LOADER_FILES = "fileLoaderFiles";
export const FILE_LOADER_REPLACE = "fileLoaderReplace";
export const FILE_LOADER_FILE_ERROR = "fileLoaderFileError";

// Form
export const FORM_RENDER = "formRender";

// FormSaveStatus
export const FORM_SAVE_CLICK = "formSaveClick";
export const FORM_SAVE_ERROR = "formSaveError";
export const FORM_CLOSE_CLICK = "formCloseClick";

// FiasInput
export const FIAS_ENTER_EDIT_MODE = "fiasEnterEditMode";
export const FIAS_OUT_EDIT_MODE = "fiasOutEditMode";
export const FIAS_CLOSE_MODAL_WITH_SAVE = "fiasCloseModalWithSave";
export const FIAS_CLOSE_MODAL_WITHOUT_SAVE = "fiasCloseModalWithoutSave";
export const FIAS_HANDLE_EDIT_MODE_VALUE_CHANGE = "fiasHandleEditModeValueChange";
export const FIAS_CHANGE_MODAL_EDIT_MODE = "fiasChangeModalEditMode";
export const FIAS_SUBMIT_ADDRESS = "fiasSubmitAddress";
export const FIAS_HANDLE_CLICK = "fiasHandleClick";
export const FIAS_FILL_BY_ID = "fiasFillById";
export const FIAS_FILL_ADDR_TYPE = "fiasFillAddrType";
export const FIAS_OPEN_MODAL = "fiasOpenModal";
export const FIAS_CLOSE_MODAL = "fiasCloseModal";
export const FIAS_SAVE_MODAL_WRONG_ID = "fiasSaveModalWrongId";
export const FIAS_SAVE_MODAL_CUSTOM_ADDRESS = "fiasSaveModalCustomAddress";
export const FIAS_SAVE_VIA_WIDGET = "fiasSaveViaWidget";

// Input, Combobox, FxInput
export const VALUE_EDITED = "valueEdited";

// Combobox, Picklist
export const PICKLIST_SEARCH = "picklistSearch";

// Select
export const SELECT_USING = "selectUsing";

// HeaderMenu
export const HEADER_MENU_CLICK = "headerMenuClick";

// HelpInfo
export const HELPINFO_SHOW = "helpinfoShow";

// HelpTooltip
export const HELPTOOLTIP_SHOW = "helptooltipShow";

// Link
export const LINK_CLICK = "linkClick";

// Banner
export const BANNER_CLICK = "bannerClick";
export const BANNER_CLOSE = "bannerClose";

// Button
export const BUTTON_CLICK = "buttonClick";

// Upload table buttons
export const EXCEL_DOWNLOAD_BUTTON_CLICK = "excelDownloadButtonClick";
export const EXCEL_UPLOAD_BUTTON_CLICK = "excelUploadButtonClick";
export const EXCEL_UPLOAD_SELECT_REPLACE = "excelUploadSelectReplace";
export const EXCEL_UPLOAD_SELECT_ADD = "excelUploadSelectAdd";
export const EXCEL_UPLOAD_FILE = "excelUploadFile";
export const EXCEL_UPLOAD_FILES = "excelUploadFiles";
export const EXCEL_UPLOAD_DELETE_FILE_FROM_LOAD = "excelUploadDeleteFileFromLoad";
export const EXCEL_UPLOAD_CLICK_CLOSE = "excelUploadClickClose";
export const EXCEL_UPLOAD_ADD_MORE_FILES_CLICK = "excelUploadAddMoreFilesClick";
export const XML_DOWNLOAD_BUTTON_CLICK = "xmlDownloadButtonClick";
export const XML_UPLOAD_BUTTON_CLICK = "xmlUploadButtonClick";
export const XML_UPLOAD_SELECT_REPLACE = "xmlUploadSelectReplace";
export const XML_UPLOAD_SELECT_ADD = "xmlUploadSelectAdd";
export const XML_UPLOAD_SELECT_DEEP_MERGE = "xmlUploadSelectDeepMerge";
export const XML_UPLOAD_FILE = "xmlUploadFile";
export const XML_UPLOAD_FILES = "xmlUploadFiles";
export const XML_UPLOAD_DELETE_FILE_FROM_LOAD = "xmlUploadDeleteFileFromLoad";
export const XML_UPLOAD_CLICK_CLOSE = "xmlUploadClickClose";
export const XML_UPLOAD_ADD_MORE_FILES_CLICK = "xmlUploadAddMoreFilesClick";

// Menu
export const UNIT_MENU_CLICK = "unitMenuClick";
export const UNIT_MENU_ADD_CLICK = "unitMenuAddClick";
export const UNIT_MENU_COPY_CLICK = "unitMenuCopyClick";
export const UNIT_MENU_CLEAR_CLICK = "unitMenuClearClick";
export const UNIT_MENU_REMOVE_CLICK = "unitMenuRemoveClick";
export const UNIT_MENU_INPUT_ENTER = "unitMenuInputEnter";
export const UNIT_MENU_NEXT_LINK_CLICK = "unitMenuNextLinkClick";
export const UNIT_MENU_PREVIOUS_LINK_CLICK = "unitMenuPreviousLinkClick";
export const UNIT_MENU_VISIBLE_BUTTON_CLICK = "unitMenuVisibleButtonClick";

// MultiLineField
export const MULTILINE_FIELD_ADD_CLICK = "multilineFieldAddClick";
export const MULTILINE_FIELD_EXPAND_CLICK = "multilineFieldExpandClick";
export const MULTILINE_FIELD_REMOVE_CLICK = "multilineFieldRemoveClick";

// NormativeHelp
export const NORMATIV_BASE_CLICK = "normativBaseClick";
export const NORMATIV_HELP_CLICK = "normativHelpClick";

// Pager
export const PAGER_INPUT_SUBMIT = "pagerInputSubmit";
export const PAGER_INTERVAL_CLICK = "pagerIntervalClick";
export const PAGER_NEXT_CLICK = "pagerNextClick";
export const PAGER_PREVIOUS_CLICK = "pagerPreviousClick";
export const PAGER_HOT_KEY_MOVE_ON_INPUT = "pagerHotKeyMoveOnInput";

// Panel
export const PANEL_TAB_CHANGE = "panelTabChange";

// Pencil
export const PENCIL_CLICK = "pencilClick";

// Pin
export const PIN_CLICK = "pinClick";

// RowMenu
export const ROW_MENU_REMOVE_CLICK = "rowMenuRemoveClick";
export const ROW_MENU_ADD_NEXT_CLICK = "rowMenuAddNextClick";
export const ROW_MENU_ADD_PREVIOUS_CLICK = "rowMenuAddPreviousClick";
export const ROW_MENU_COPY_NEXT_CLICK = "rowMenuCopyNextClick";
export const ROW_MENU_COPY_LAST_CLICK = "rowMenuCopyLastClick";

// Row Buttons
export const ADD_ROW_BUTTON_CLICK = "addRowButtonClick";
export const REMOVE_ROW_BUTTON_CLICK = "removeRowButtonClick";

// uploadFuf
export const UPLOAD_FUF = "uploadFuf";

// uploadFufAttachments
export const UPLOAD_FUF_ATTACHMENTS = "uploadFufAttachments";

// ScrollableContainer
export const SCROLLABLE_CONTAINER_LEFT_ARROW_CLICK = "scrollableContainerLeftArrowClick";
export const SCROLLABLE_CONTAINER_RIGHT_ARROW_CLICK = "scrollableContainerRightArrowClick";
export const SCROLLABLE_CONTAINER_SCROLL_MOUSEDOWN = "scrollableContainerScrollMousedown";

// ShowCheckingStatus
export const ERROR_LOG_REQUEST_FAILED = "errorLogRequestFailed";

// SortRadioGroup
export const SORT_RADIO_CLICK = "sortRadioClick";

// TableCell
export const TABLECELL_PENCIL_CLICK = "tablecellPencilClick";

// Templates
export const ACCEPT_LOAD_TEMPLATE_CLICK = "acceptLoadTemplateClick";
export const ACCEPT_CREATE_TEMPLATE_CLICK = "acceptCreateTemplateClick";
export const ACCEPT_RENAME_TEMPLATE_CLICK = "acceptRenameTemplateClick";
export const CANCEL_CREATE_TEMPLATE_CLICK = "cancelCreateTemplateClick";
export const CANCEL_LOAD_TEMPLATE_CLICK = "cancelLoadTemplateClick";
export const CANCEL_RENAME_TEMPLATE_CLICK = "cancelRenameTemplateClick";
export const CREATE_TEMPLATE_CLICK = "createTemplateClick";
export const DELETE_TEMPLATE_CLICK = "deleteTemplateClick";
export const LOAD_TEMPLATE_CLICK = "loadTemplateClick";
export const RENAME_TEMPLATE_CLICK = "renameTemplateClick";
export const RESTORE_TEMPLATE_CLICK = "restoreTemplateClick";

// Unit
export const ADD_UNIT_CLICK = "addUnitClick";
export const REMOVE_UNIT_CLICK = "removeUnitClick";
export const COPY_UNIT_CLICK = "copyUnitClick";

export const ENABLE_AUTO_VALUES_PAGE = "enableAutoValuesOnPage";
export const ADD_PAGE = "addPage";
export const REMOVE_PAGE_MODAL_OPEN = "removePageModalOpen";
export const REMOVE_PAGE = "removePage";
export const CLEAR_PAGE_MODAL_OPEN = "clearPageModalOpen";
export const CLEAR_PAGE = "clearPage";
export const ADD_XML_PAGE_MODAL_OPEN = "addXmlPageModalOpen";

export const UNIT_LIST_COLLAPSE = "collapseNestedUnits";

// Multiline Unit
export const MULTILINE_UNIT_CLICK = "multilineUnitClick";

// UnitLabel
export const ACCEPT_EDIT_UNIT_NAME_CLICK = "acceptEditUnitNameClick";
export const CANCEL_EDIT_UNIT_NAME_CLICK = "cancelEditUnitNameClick";
export const EDIT_UNIT_NAME_CLICK = "editUnitNameClick";

// Tour
export const TOUR_SHOW = "tourShow";
export const TOUR_SHOWN = "tourShown";
export const NEXT_STEP_CLICK = "nextStepClick";
export const BACK_STEP_CLICK = "backStepClick";

// ViewFile
export const VIEW_FILE_ERROR = "viewFileError";
export const VIEW_FILE_WARNING = "viewFileWarning";
export const VIEW_FILE_TOOLTIP = "viewFileTooltip";
export const VIEW_FILE_TOOLTIP_REMOVE = "viewFileTooltipRemove";
export const VIEW_FILE_TOOLTIP_CANCEL = "viewFileTooltipCancel";

// inn
export const SHOW_FOCUS_NOT_WORK_HELP_CLICK = "showFocusNotWorkHelpClick";

// ExpertNote
export const EXPERT_CREACTE_IN_EXPERT_CLICK = "expertCreateInExpertClick";
export const EXPERT_REPLACE_WITH_EXPERT_CLICK = "expertReplaceWithExpertClick";

export const EXPERT_ERROR_LOG_COUNTER = "expertErrorLogCounter";
export const EXPERT_ERROR_LOG_REQUEST_FAILED = "expertLogRequestFailed";
export const EXPERT_GENERATE_ERROR = "expertGenerateError";

export const EXPERT_ERRORS_PAGE_DOWNLOAD_ERROR_LOG_CLICK = "expertErrorsPageDownloadErrorLogClick";
export const EXPERT_ERRORS_PAGE_GENERATE_NOTE_CLICK = "expertErrorsPageGenerateNoteClick";
export const EXPERT_ERRORS_PAGE_CANCEL_CLICK = "expertErrorsPageCancelClick";
export const EXPERT_ERRORS_PAGE_CANCEL_REQUEST = "expertErrorsPageCancelRequest";
export const EXPERT_ERRORS_RELOAD_ERROR_LOG_CLICK = "expertErrorsPageReloadErrorLogClick";
export const EXPERT_ERRORS_NAVIGATE_TO_UNIT_CLICK = "expertErrorsPageNavigateToUnitClick";

export const EXPERT_PREVIEW_PAGE_CANCEL_CLICK = "expertPreviewPageCancelClick";
export const EXPERT_PREVIEW_PAGE_CANCEL_REQUEST = "expertPreviewPageCancelRequest";
export const EXPERT_PREVIEW_PAGE_ATTACH_CLICK = "expertPreviewPageAttachClick";
export const EXPERT_PREVIEW_PAGE_DOWNLOAD_CLICK = "expertPreviewPageDownloadClick";
export const EXPERT_PREVIEW_PAGE_RELOAD_NOTE_CLICK = "expertPreviewPageReloadNoteClick";

export const EXPERT_REPLACE_PAGE_REPLACE_CLICK = "expertReplacePageReplaceClick";
export const EXPERT_REPLACE_PAGE_CANCEL_CLICK = "expertReplacePageCancelClick";
export const EXPERT_REPLACE_PAGE_CANCEL_REQUEST = "expertReplacePageCancelRequest";
export const EXPERT_REPLACE_PAGE_DOWNLOAD_CLICK = "expertReplacePageDownloadClick";

// Spoiler
export const SPOILER_SHOW_CLICK = "spoilerShowClick";
export const SPOILE_HIDE_CLICK = "spolierHideClick";

// ViewMode Selector
export const VIEWMODE_SELECTOR_OPEN = "viewModeSelectorOpen";
export const VIEWMODE_CHANGE_CAPTIONS = "viewModeChangeCaptions";
export const VIEWMODE_CHANGE_HINTS = "viewModeChangeHints";

// Ie Deprecation lightbox
export const IE_DEPRECATION_WARNING_OPENED = "ieDeprecationWarningOpened";
export const IE_DEPRECATION_BROWSER_SELECTED = "ieDeprecationBrowserSelected";
export const IE_DEPRECATION_OPEN_CURRENT_BROWSER = "ieDeprecationBrowserOpenCurrentBrowser";

// Ie Store size
export const IE_STORE_SIZE_OPENED = "ieStoreSizeOpned";
export const IE_STORE_SIZE_BROWSER_SELECTED = "ieStoreSizeBrowserSelected";

// patchFufByAttachmentModal
export const PATCH_FUF_MODAL_OPEN = "patchFufModalOpen";
export const PATCH_FUF_MODAL_CLOSE = "patchFufModalClose";
export const PATCH_FUF_MODAL_SET_COMBINE_METHOD = "patchFufModalSetCombineMethod";
export const PATCH_FUF_MODAL_DELETE_FILE = "patchFufModalDeleteFile";
export const PATCH_FUF_MODAL_UPLOAD_FILE = "patchFufModalUploadFile";
export const PATCH_FUF_MODAL_TRANSFER_TYPE = "patchFufModalTransferType";

// minitour
export const MINITOUR_CLOSED = "minitourClosed";
export const MINITOUR_SHOW = "minitourShow";

// Zero Reporting
export const ZERO_REPORT_MODAL_OPEN = "zeroReportModalOpen";
export const ZERO_REPORT_MODAL_CLOSE = "zeroReportModalClose";
export const ZERO_REPORT_MODAL_FILL = "zeroReportModalFill";
export const ZERO_REPORT_MODAL_ERROR = "zeroReportModalError";

//ChangeSet
export const CHANGE_SET_CONFLICT = "changeSetConflict";

// Additional error protocol
export const OPEN_PO_PD_PROTOCOL = "openPopdProtocol";
export const RUN_PO_PD_CHECK = "runPopdCheck";

// Checkbox
export const CHECKBOX = "checkbox";

// Toggle
export const TOGGLE = "toggle";

// StaffService
export const EMPLOYER_DOCUMENTS_CALL_SOURCE = "employerDocumentsCallSource";
export const EMPLOYER_DOCUMENTS_COUNT = "employerDocumentsCount";
export const EMPLOYER_DOCUMENTS_CANCEL = "employerDocumentsCancel";
export const EMPLOYER_DOCUMENTS_CLOSE = "employerDocumentsClose";
export const EMPLOYER_DOCUMENT_IMPORT = "employerDocumentImport";
export const EMPLOYER_DOCUMENTS_WARNING_SIZE = "employerDocumentsWarningSize";
export const RELATIVES_COMBOBOX_OPEN = "relativesComboBoxOpen";
export const RELATIVES_COMBOBOX_LOADED = "relativesComboBoxLoaded";
export const RELATIVES_COMBOBOX_SELECTED = "relativesComboBoxSelected";
export const RELATIVES_COMBOBOX_ADD = "relativesComboBoxAdd";
export const RELATIVES_COMBOBOX_UNEXPECTED_INPUT = "relativesComboBoxUnexpectedInput";

// TreePicklist
export const TREE_PICKLIST_OPEN_MODAL = "treePicklistOpenModal";
export const TREE_PICKLIST_CLOSE_MODAL = "treePicklistCloseModal";
export const TREE_PICKLIST_TOGGLE_ITEM = "treePicklistPickItem";
export const TREE_PICKLIST_TOGGLE_SUMMARY = "treePicklistToggleSummary";
export const TREE_PICKLIST_RESET_VALUES = "treePicklistResetValues";
export const TREE_PICKLIST_SEARCH_MODAL_INPUT = "treePicklistSearchModalInput";
export const TREE_PICKLIST_TYPE_IN_INPUT = "treePicklistTypeInInput";

// ModalForm
export const MODAL_FORM_OPEN = "modalFormOpen";
export const MODAL_FORM_ACCEPT = "modalFormAccept";
export const MODAL_FORM_CANCEL = "modalFormCancel";
export const MODAL_FORM_REMOVE = "modalFormRemove";
export const MODAL_FORM_CONFIRM_OPEN = "modalFormConfirmOpen";
export const MODAL_FORM_CONFIRM_ACCEPT = "modalFormConfirmAccept";
export const MODAL_FORM_CONFIRM_CANCEL = "modalFormConfirmCancel";

// OptionalBlock
export const CREATE_OPTIONAL_BLOCK = "createOptionalBlock";
export const DELETE_OPTIONAL_BLOCK = "deleteOptionalBlock";

// Server Side Calculations
export const SSC_REQUEST_EXECUTED = "sscRequestExecuted";
export const SSC_REQUEST_WITH_CALLBACK_DATA_EXECUTED = "sscRequestWithCallbackDataExecuted";

// ContractorsSuggestComboBox
export const CONTRACTORS_SUGGEST_COMBOBOX_OPEN_SIDE_PAGE = "contractorsSuggestComboBoxOpenSidePage";
export const CONTRACTORS_SUGGEST_COMBOBOX_SELECT = "contractorsSuggestComboBoxSelect";
